import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Instruction,
  InstructionOptions
} from "../../../../models/instruction";
import MultipleSelection from "../../MultipleSelection";
import Stack from "@mui/material/Stack";

import Modal from "../../../Generic/Modal";

import useStyles from "./styles";

type Props = {
  isModalOpen: boolean;
  closeModal: () => void;
  instructionOptions: InstructionOptions[];
  selectedInstructions?: Instruction[];
  selectedWhen?: string;
  submit: (instructions: InstructionOptions[]) => void;
};

const InstructionsModal = ({
  isModalOpen,
  closeModal,
  instructionOptions,
  selectedInstructions,
  selectedWhen,
  submit
}: Props) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  const [selectedInstructionOptions, setSelectedInstructionOptions] = useState<
    InstructionOptions[]
  >([]);

  const onSelectInstruction = (itemId: number, isItemSelected: boolean) => {
    let instructionsAux: InstructionOptions[] = [...selectedInstructionOptions];

    if (isItemSelected) {
      const selectedInstruction = instructionOptions.find(
        instruction => instruction.id === itemId
      ) as InstructionOptions;
      instructionsAux.push(selectedInstruction);
    } else {
      instructionsAux = instructionsAux.filter(
        instruction => instruction.id !== itemId
      );
    }

    setSelectedInstructionOptions(instructionsAux);
  };

  const parseSelectedInstructions = (): number[] => {
    let selectedInstructionOptionsNames: string[] = selectedInstructions
      ?.filter(instruction => instruction.when === selectedWhen)
      .map(instruction => instruction.name) as string[];

    let selectedInstructionOptionsIds: number[] = instructionOptions
      .filter(instruction =>
        selectedInstructionOptionsNames.includes(instruction.name)
      )
      .map(instruction => instruction.id) as number[];

    let selectedInstructionIds: number[] = selectedInstructionOptions.map(
      instruction => instruction.id
    ) as number[];

    return selectedInstructionOptionsIds.concat(selectedInstructionIds);
  };

  return (
    <Modal
      title={translate("availableInstructions")}
      open={isModalOpen}
      handleClose={closeModal}
      data-cy="modal-instructions"
      showActionButtons
      actionButtonProps={{
        dataCyCancel: "cancel-instructions-modal",
        dataCySave: "save-instructions-modal",
        textSave: translate("add"),
        onCancel: () => {
          closeModal();
          setSelectedInstructionOptions([]);
        },
        onSave: () => {
          submit(selectedInstructionOptions);
          setSelectedInstructionOptions([]);
        }
      }}
    >
      <Stack
        className={classes.mainDiv}
        spacing={1}
        alignItems="flex-start"
        justifyContent="flex-start"
      >
        {parseSelectedInstructions().length > 0 ? (
          <span className={classes.countSpan}>{`${
            selectedInstructionOptions.length
          } ${translate("selectedInstructions")}`}</span>
        ) : null}
        <MultipleSelection
          data={instructionOptions}
          onSelectItem={onSelectInstruction}
        />
      </Stack>
    </Modal>
  );
};

export default InstructionsModal;
